const SET_PAYMENT_MODAL_OPEN = 'SET_PAYMENT_MODAL_OPEN';
const SET_PAYMENT_STEPS_OPEN = 'SET_PAYMENT_STEPS_OPEN';

const SET_PAYMENT_RESULT = 'SET_PAYMENT_RESULT';
const SET_PAYMENT_ERROR = 'SET_PAYMENT_ERROR';
const SET_PAYMENT_ERROR_COUNT = 'SET_PAYMENT_ERROR_COUNT';
const SET_PAYMENT_CONFIRMATION_ID = 'SET_PAYMENT_CONFIRMATION_ID';

const SET_STEP_FIRST_DONE = 'SET_STEP_FIRST_DONE';
const SET_STEP_SECOND_DONE = 'SET_STEP_SECOND_DONE';
const SET_STEP_THIRD_DONE = 'SET_STEP_THIRD_DONE';
const SET_STEP_FOURTH_DONE = 'SET_STEP_FOURTH_DONE';

const SET_USER = 'SET_USER';
const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';
const SET_PAYMENT_AMOUNT = 'SET_PAYMENT_AMOUNT';
const SET_PAYMENT_CUSTOM_AMOUNT = 'SET_PAYMENT_CUSTOM_AMOUNT';
const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
const SET_PAYMENT_CARD_NUMBER = 'SET_PAYMENT_CARD_NUMBER';
const SET_PAYMENT_CARD_NUMBER_SPACED= 'SET_PAYMENT_CARD_NUMBER_SPACED';
const SET_PAYMENT_CARD_NUMBER_ERROR = 'SET_PAYMENT_CARD_NUMBER_ERROR';
const SET_PAYMENT_MONTH = 'SET_PAYMENT_MONTH';
const SET_PAYMENT_MONTH_ERROR = 'SET_PAYMENT_MONTH_ERROR';
const SET_PAYMENT_YEAR = 'SET_PAYMENT_YEAR';
const SET_PAYMENT_YEAR_ERROR = 'SET_PAYMENT_YEAR_ERROR';
const SET_PAYMENT_CVV = 'SET_PAYMENT_CVV';
const SET_PAYMENT_CVV_ERROR = 'SET_PAYMENT_CVV_ERROR';
const SET_PAYMENT_FIRST_NAME = 'SET_PAYMENT_FIRST_NAME';
const SET_PAYMENT_FIRST_NAME_ERROR = 'SET_PAYMENT_FIRST_NAME_ERROR';
const SET_PAYMENT_LAST_NAME = 'SET_PAYMENT_LAST_NAME';
const SET_PAYMENT_LAST_NAME_ERROR = 'SET_PAYMENT_LAST_NAME_ERROR';
const SET_PAYMENT_ADDRESS = 'SET_PAYMENT_ADDRESS';
const SET_PAYMENT_ADDRESS_ERROR = 'SET_PAYMENT_ADDRESS_ERROR';
const SET_PAYMENT_STATE = 'SET_PAYMENT_STATE';
const SET_PAYMENT_STATE_ERROR = 'SET_PAYMENT_STATE_ERROR';
const SET_PAYMENT_CITY = 'SET_PAYMENT_CITY';
const SET_PAYMENT_CITY_ERROR = 'SET_PAYMENT_CITY_ERROR';
const SET_PAYMENT_ZIP_CODE = 'SET_PAYMENT_ZIP_CODE';
const SET_PAYMENT_ZIP_CODE_ERROR = 'SET_PAYMENT_ZIP_CODE_ERROR';
const SET_PAYMENT_BANK_ACCOUNT = 'SET_PAYMENT_BANK_ACCOUNT';
const SET_PAYMENT_BANK_ACCOUNT_ERROR = 'SET_PAYMENT_BANK_ACCOUNT_ERROR';
const SET_PAYMENT_BANK_ACCOUNT_NAME = 'SET_PAYMENT_BANK_ACCOUNT_NAME';
const SET_PAYMENT_BANK_ACCOUNT_NAME_ERROR = 'SET_PAYMENT_BANK_ACCOUNT_NAME_ERROR';
const SET_PAYMENT_ROUTING_NUMBER = 'SET_PAYMENT_ROUTING_NUMBER';
const SET_PAYMENT_ROUTING_NUMBER_ERROR = 'SET_PAYMENT_ROUTING_NUMBER_ERROR';
const SET_PAYMENT_ACCOUNT_TYPE = 'SET_PAYMENT_ACCOUNT_TYPE';
const SET_PAYMENT_ACCOUNT_TYPE_ERROR = 'SET_PAYMENT_ACCOUNT_TYPE_ERROR';
const SET_CONFIRM_TYPE = 'SET_CONFIRM_TYPE';
const SET_CONFIRM_EMAIL = 'SET_CONFIRM_EMAIL';
const SET_CONFIRM_CUSTOM_EMAIL = 'SET_CONFIRM_CUSTOM_EMAIL';
const SET_FORM_ACCOUNT_NUMBER = 'SET_FORM_ACCOUNT_NUMBER';
const SET_FORM_ZIP_CODE = 'SET_FORM_ZIP_CODE';
const SET_FORM_ERROR = 'SET_FORM_ERROR';
const SET_LOADING = 'SET_LOADING';
const SET_ACCOUNT_FORM_LOADING = 'SET_ACCOUNT_FORM_LOADING';


const combineConst = {
    SET_PAYMENT_MODAL_OPEN,
    SET_PAYMENT_STEPS_OPEN,
    SET_PAYMENT_RESULT,
    SET_PAYMENT_ERROR,
    SET_PAYMENT_ERROR_COUNT,
    SET_PAYMENT_CONFIRMATION_ID,
    SET_STEP_FIRST_DONE,
    SET_STEP_SECOND_DONE,
    SET_STEP_THIRD_DONE,
    SET_STEP_FOURTH_DONE,
    SET_USER,
    SET_PAYMENT_TYPE,
    SET_PAYMENT_AMOUNT,
    SET_PAYMENT_CUSTOM_AMOUNT,
    SET_PAYMENT_METHOD,
    SET_PAYMENT_CARD_NUMBER,
    SET_PAYMENT_CARD_NUMBER_SPACED,
    SET_PAYMENT_CARD_NUMBER_ERROR,
    SET_PAYMENT_MONTH,
    SET_PAYMENT_MONTH_ERROR,
    SET_PAYMENT_YEAR,
    SET_PAYMENT_YEAR_ERROR,
    SET_PAYMENT_CVV,
    SET_PAYMENT_CVV_ERROR,
    SET_PAYMENT_FIRST_NAME,
    SET_PAYMENT_FIRST_NAME_ERROR,
    SET_PAYMENT_LAST_NAME,
    SET_PAYMENT_LAST_NAME_ERROR,
    SET_PAYMENT_ADDRESS,
    SET_PAYMENT_ADDRESS_ERROR,
    SET_PAYMENT_STATE,
    SET_PAYMENT_STATE_ERROR,
    SET_PAYMENT_CITY,
    SET_PAYMENT_CITY_ERROR,
    SET_PAYMENT_ZIP_CODE,
    SET_PAYMENT_ZIP_CODE_ERROR,
    SET_PAYMENT_BANK_ACCOUNT,
    SET_PAYMENT_BANK_ACCOUNT_ERROR,
    SET_PAYMENT_BANK_ACCOUNT_NAME,
    SET_PAYMENT_BANK_ACCOUNT_NAME_ERROR,
    SET_PAYMENT_ROUTING_NUMBER,
    SET_PAYMENT_ROUTING_NUMBER_ERROR,
    SET_PAYMENT_ACCOUNT_TYPE,
    SET_PAYMENT_ACCOUNT_TYPE_ERROR,
    SET_CONFIRM_TYPE,
    SET_CONFIRM_EMAIL,
    SET_CONFIRM_CUSTOM_EMAIL,
    SET_FORM_ACCOUNT_NUMBER,
    SET_FORM_ZIP_CODE,
    SET_FORM_ERROR,
    SET_LOADING,
    SET_ACCOUNT_FORM_LOADING
};

export default combineConst;
